@if (link) {
<a [routerLink]="link" [matTooltip]="name">
  <pet-icon aria-hidden="true" [hasWarning]="isIncomplete"></pet-icon>
  <span class="visually-hidden">{{ name }} - Pet</span>
</a>
} @if (!link) {
<span [matTooltip]="name">
  <pet-icon aria-hidden="true" [hasWarning]="isIncomplete"></pet-icon>
  <span class="visually-hidden">{{ name }} - Pet</span>
</span>
}
